import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const Comment = ({ comment }) => {
  return (
    <div className="comment-wrapper">
      <div className="comment-author-picture">
        {comment.avatarUrl ? (
          <img src={comment.avatarUrl} />
        ) : (
          <div className="avatar-placeholder">
            <div className="avatar-name">{comment.commentAuthorInitial}</div>
          </div>
        )}
      </div>
      <div className="comment-container">
        <div className="comment-detail">
          <div className="article-title">
            <div className="comment-author-picture-mobile">
              {comment.avatarUrl ? (
                <img src={comment.avatarUrl} />
              ) : (
                <div className="avatar-placeholder">
                  <div className="avatar-name">{comment.commentAuthorInitial}</div>
                </div>
              )}
            </div>
            <div className="article-detail">
              <div>
                <a href={comment.commentableUrl}>{comment.commentableTitle}</a>
              </div>
              <div className="commented-by">
                <span>Commented By: {comment.author}</span>
              </div>
            </div>
          </div>
          <div className="comment-body">{ReactHtmlParser(comment.body)}</div>
        </div>
        <div className="comment-actions">
          <div className="comment-actions-container">
            <div className="comment-date">{comment.commentCreated}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Comment;
